import { connect } from 'react-redux';
import { getMktplaceUser } from '../../actions';

import GetDemoView from './GetDemoView';

const mapStateToProps = (state) => {
  const { session, request } = state;
  return {
    awsToken: session.awsToken,
    isLoading: request.AWS_MKTPLACE_TOKEN_REQUEST,
  };
};

export default connect(mapStateToProps, {
  getMktplaceUser,
})(GetDemoView);
